import Nullstack from 'nullstack';
export default function IconLuggage({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-luggage",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "6",
    y: "6",
    width: "12",
    height: "14",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M9 6v-1a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1"
  }), "   ", Nullstack.element("path", {
    d: "M6 10h12"
  }), "   ", Nullstack.element("path", {
    d: "M6 16h12"
  }), "   ", Nullstack.element("path", {
    d: "M9 20v1"
  }), "   ", Nullstack.element("path", {
    d: "M15 20v1"
  }), " ");
}